<template>
  <section id="modals">
    <div class="demo">
      <p class="d-flex flex-column flex-md-row justify-content-around">

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#exampleModalCenter">
          default
        </button>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#exampleModalMsg">
          Centered
        </button>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#exampleModalLarge">
          Large
        </button>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#exampleModalLong">
          Long content
        </button>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#fullScreenModal">
          Full screen
        </button>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary mb-3" data-toggle="modal" data-target="#fitContentModal">
          Fit content
        </button>
      </p>
    </div>
    <!-- Modal long-->
    <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="exampleModalLongTitle">Modal - long content</h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="gel-icon-close gel-icon-lg"></span>
            </button>
          </div>
          <div class="modal-body vh-70 overflow-y-auto">
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
            <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal large-->
    <div class="modal fade" id="exampleModalLarge" tabindex="-1" role="dialog" aria-labelledby="exampleModalLarge" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="exampleModalLongTitle">Modal - long content</h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="gel-icon-close gel-icon-lg"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
            <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal default -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="exampleModalCenterTitle">Modal title</h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="gel-icon-close gel-icon-lg"></span>
            </button>
          </div>
          <div class="modal-body">
            <h5>Modal content</h5>
            Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal full screen-->
    <div class="modal fade" id="fullScreenModal" tabindex="-1" role="dialog" aria-labelledby="fullScreenModal" aria-hidden="true">
      <div class="modal-dialog modal-full" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="exampleModalCenterTitle">Modal title</h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="gel-icon-close gel-icon-lg"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="embed-responsive embed-responsive-4by3">
              <iframe class="embed-responsive-item" src="https://getbootstrap.com/"></iframe>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal default -->
    <div class="modal fade" id="exampleModalMsg" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="gel-icon-close gel-icon-lg"></span>
            </button>
          </div>
          <div class="modal-body">
            <article class="bg-white p-3 rounded text-center">
              <svg width="84px" height="84px" viewbox="0 0 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Success illustration</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Artboard" transform="translate(-349.000000, -160.000000)">
                    <g id="Success-illustration" transform="translate(349.000000, 160.000000)">
                      <circle id="Oval" fill="#D7F3D2" cx="41.5578947" cy="41.5578947" r="34.4842105"></circle>
                      <g id="noun_success_2019805" fill="#328423">
                        <path
                          d="M41.8231579,83.1157895 C18.8336842,83.0273684 0.265263158,64.4589474 0.353684211,41.4694737 C0.442105263,18.48 19.0105263,-0.0884210526 42,6.2824637e-15 C46.4210526,6.2824637e-15 50.7536842,0.707368421 54.9094737,2.12210526 C55.8821053,2.38736842 56.4126316,3.36 56.1473684,4.33263158 C55.8821053,5.30526316 54.8210526,5.74736842 53.9368421,5.48210526 C53.9368421,5.48210526 53.8484211,5.48210526 53.8484211,5.48210526 C33.6884211,-1.14947368 12.0252632,9.81473684 5.48210526,29.8863158 C4.24421053,33.6884211 3.53684211,37.5789474 3.53684211,41.5578947 C3.71368421,62.6905263 21.0442105,79.6673684 42.1768421,79.4905263 C60.8336842,79.3136842 76.5726316,65.6968421 79.5789474,47.3052632 C79.7557895,46.3326316 80.64,45.6252632 81.6126316,45.8021053 C82.5852632,45.9789474 83.2926316,46.8631579 83.1157895,47.8357895 C80.0210526,67.9957895 62.2484211,83.1157895 41.8231579,83.1157895 Z"
                          id="Path"></path>
                        <path
                          d="M40.2315789,55.3515789 C39.7894737,55.3515789 39.3473684,55.1747368 38.9936842,54.8210526 L21.7515789,37.6673684 C21.0442105,36.96 21.0442105,35.8989474 21.7515789,35.1915789 C22.4589474,34.4842105 23.52,34.4842105 24.2273684,35.1915789 L40.2315789,51.1073684 L76.9263158,14.5894737 C77.5452632,13.8821053 78.6947368,13.7936842 79.4021053,14.5010526 C80.1094737,15.12 80.1978947,16.2694737 79.4905263,16.9768421 C79.4905263,16.9768421 79.4021053,17.0652632 79.4021053,17.0652632 L41.4694737,54.8210526 C41.1157895,55.1747368 40.6736842,55.3515789 40.2315789,55.3515789 Z"
                          id="Path"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <p class="mt-4">You have successfully created a task!</p>
              <p>
                <button class="btn btn-outline-primary">
                  Add another one</button>
              </p>
            </article>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal fit content -->
    <div class="modal fade" id="fitContentModal" tabindex="-1" role="dialog" aria-labelledby="fitContentModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-fit-content" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Fit content modal</h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="gel-icon-close gel-icon-lg"></span>
            </button>
          </div>
          <div class="modal-body vh-70 overflow-y-auto">
            <div>Using your FOXID, log into Foxlink and&nbsp;complete the tasks listed below:<br><br>1.
              <strong>Complete&nbsp;Electronic W2 Consent</strong><br>Log into FoxLink -&gt; select the Employee tab and click "My Payroll/HR" -&gt; the Electronic W2 Consent will be located under the&nbsp;"Taxes" section.<br><img height="260" width="885" src="https://publicstorage.dc4.pageuppeople.com/777/ProviderAsset/scribble/679daae8-b6f7-49e3-8aa1-185595bb5682.png"><br>2.
              <strong>Complete Ethnicity Race Survey</strong><br>Log into FoxLink -&gt; select the Employee tab and&nbsp;click "Administration" -&gt; the Ethnicity Race Survey will be located under the "Ethnicity Race" section.<br><img height="338" width="538" src="https://publicstorage.dc4.pageuppeople.com/777/ProviderAsset/scribble/c9dad9cf-6259-48c1-bd79-f658e62008fb.png"><br>3.
              <strong>Register for the Rollins Alert System</strong><br>Log into FoxLink -&gt; select the Community tab -&gt; the Rollins Alert System will be located under the "Campus Safety" section.<br><img height="293" width="878" src="https://publicstorage.dc4.pageuppeople.com/777/ProviderAsset/scribble/5d7a19de-c744-418d-ad3c-357bb13ea830.png"><br>4.
              <strong>Review Public Directory Photo Options<br></strong>Would you like your R-Card photo to appear in the College's public directory?
              <br>Log into FoxLink -&gt; select the Employee tab and&nbsp;click "Administration" -&gt; the Public Directory Photo option will be located under the "Campus Directory" section.<br><img height="332" width="528" src="https://publicstorage.dc4.pageuppeople.com/777/ProviderAsset/scribble/448d67b0-4e8f-4c83-bbeb-a1536721b53a.png"><br>5.
              <strong>Birthdays!</strong><br>Want to know somebody's birthday? Check out the Birthdays! link.<br>Log into FoxLink -&gt; select the Community tab -&gt; the "Birthdays!" will be located under the "Campus Only Access" section.<br><img height="267" width="892" src="https://publicstorage.dc4.pageuppeople.com/777/ProviderAsset/scribble/d21cc98a-49f1-422d-b9f1-ddaff041e288.png"><br>For more information please visit:
              <a rel="noopener noreferrer" href="https://www.rollins.edu/it/accounts/foxlink.html">https://www.rollins.edu/it/accounts/foxlink</a>.</div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary">Action</button>
          </div>
        </div>
      </div>
    </div>
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import mdfile from "@/docs/components/modals.md";
export default {
  name: "modals",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.modals.name);
    this.$emit("update-tagline", this.$root.yamlData.components.modals.description);
  },
  mounted: function () {
    const modals = document.querySelectorAll('[data-toggle="modal"]')
    modals.forEach(modal => {
      new BSN.Modal(modal)
    })
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
